<template>
  <div class="reason-modal">
    <p class="note" v-if="note">{{ note }}</p>
    <div class="fld">
      <label class="fld-label">ເຫດຜົນ <i class="req">*</i></label>
      <textarea class="fld-input" rows="3" v-model="reason" maxlength="500"
                placeholder="ເຫດຜົນຈະຖືກບັນທຶກໄວ້ ແລະ ເຫັນໄດ້ໃນປະຫວັດ"></textarea>
      <p class="fld-hint counter">{{ reason.length }} / 500</p>
    </div>
    <p class="form-error" v-if="error">{{ error }}</p>
    <div class="modal-actions">
      <button class="cod-btn is-ghost" @click="$emit('close')">ຍົກເລີກ</button>
      <button class="cod-btn is-danger" :disabled="saving || !reason.trim()" @click="submit">
        {{ saving ? 'ກຳລັງດຳເນີນການ...' : confirmLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReasonModal',
  props: {
    note: {type: String, default: ''},
    confirmLabel: {type: String, default: 'ຢືນຢັນ'},
    saving: {type: Boolean, default: false},
    error: {type: String, default: null},
  },
  data() {
    return {reason: ''};
  },
  methods: {
    submit() {
      if (!this.reason.trim()) {
        return;
      }
      this.$emit('submit', this.reason.trim());
    },
  },
};
</script>

<style lang="scss" scoped>
@import './cod-advance-ui';

.reason-modal {
  text-align: left;
  width: 440px;
  max-width: 100%;
  color: $cod-ink;
}

.note {
  color: $cod-muted;
  font-size: 13px;
  margin-bottom: 14px;
}

.counter {
  text-align: right;
  margin: 6px 0 0;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
